import {Controller, useFormContext} from "react-hook-form";
import {FormField} from "../../../../../../design-system/form-field";
import {ProductVariantsFormValues} from "../../types";
import {usePricingCurrencies} from "@/features/currencies";
import {CardRadioGroup} from "../../../../../../components/shared/card-radio-group";

type VariantOptionListItemOptionPriceTypeFormFieldProps = {
  variantIndex: number;
  optionIndex: number;
  id: string;
};

export function VariantOptionListItemOptionPriceTypeFormField({
  optionIndex,
  variantIndex,
  id,
}: VariantOptionListItemOptionPriceTypeFormFieldProps) {
  const pricingCurrencies = usePricingCurrencies();
  const {control, clearErrors} = useFormContext<ProductVariantsFormValues>();
  return (
    <div>
      <FormField
        id={id}
        label={"Set a price"}
        renderInput={(id) => (
          <Controller
            control={control}
            name={`variants.${variantIndex}.options.${optionIndex}.priceType`}
            render={({field: {onChange, value, name, onBlur, ref}}) => (
              <CardRadioGroup
                id={id}
                name={name}
                value={value}
                onChange={(val) => {
                  clearErrors(
                    `variants.${variantIndex}.options.${optionIndex}.currencies`
                  );
                  onChange(val);
                }}
                onBlur={onBlur}
                ref={ref}
                options={[
                  {
                    value: "free",
                    title: "Free",
                    description: "Give customers free access",
                  },
                  {
                    value: "paid",
                    title: "Single fee",
                    description: "Charge a one-time fee",
                    disabled: !pricingCurrencies.connectedBankStatus.isBankConnected,
                    tooltipTitle: !pricingCurrencies.connectedBankStatus.isBankConnected
                      ? pricingCurrencies.connectedBankStatus.errorMessageString
                      : null,
                  },
                ]}
              />
            )}
          />
        )}
      />
    </div>
  );
}
